import { RateCurrency } from 'shared/price-utilities'

const shouldShowValueInSmall = value => value >= 10

const MarkerRateCounter = ({ opngo, rate, canBuy }) => {
    const rateClassName = rate && shouldShowValueInSmall(rate.amount) ? 'small' : ''

    return (
        rate &&
        !opngo && (
            <span className={rateClassName}>
                <RateCurrency
                    value={rate.amount}
                    currency={rate.currency}
                    minimumFractionDigits={rate.fractionDigits}
                    maximumFractionDigits={rate.fractionDigits}
                />
            </span>
        )
    )
}

export default MarkerRateCounter
